module.exports = __webpack_public_path__ + "img/logo-back.286f3de4.svg";